import React from 'react';
import { useTranslation } from 'react-i18next';
import { Paragraph, Modal, ModalHeader, ModalContent } from '@increasecard/typed-components';
import { ModalButtonFullWidth } from '@card/commonlib';

type AutoRenewalModalProps = {
  visible: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const mockFunction = () => null;

export function ConfirmAutoRenewalModal({ visible, onClose, onConfirm }: AutoRenewalModalProps) {
  const { t } = useTranslation();

  return (
    <Modal
      fullWidthActionButtons
      onCancel={mockFunction}
      onClose={onClose}
      onOk={mockFunction}
      visible={visible}
    >
      <ModalHeader align="left">{t('abm:Shops:AutoRenewalModal:title')}</ModalHeader>
      <ModalContent align="left" scrollable>
        <Paragraph>{t('abm:Shops:AutoRenewalModal:description_1')}</Paragraph>
        <br />
        <Paragraph>{t('abm:Shops:AutoRenewalModal:description_2')}</Paragraph>
      </ModalContent>
      <ModalButtonFullWidth onClick={onConfirm}>
        {t('abm:Shops:AutoRenewalModal:done')}
      </ModalButtonFullWidth>
    </Modal>
  );
}
